import { f } from 'vue3-observe-visibility';
import { createStore } from 'vuex'
import cookie from 'vue-cookie'
const crmPost = (action, payload) => axios.post(window.CRMProxy + '/v1/' + action, payload)
// var querystring = require('querystring');
// const tokenAuthCrm = cookie.get('crm_auth_token');

export default createStore({
    state: {
        pageSetup: null,
        formSetup: null,
        indexPromo: null,
        aboutArr: null,
        locationArr: null,
        aroundArr: null,
        studyArr: null,
        genplanArr: null,
        archArr: null,
        terracesArr: null,
        cityHousesArr: null,
        taunHouse: null,
        streetRetailArr: null,
        landArr: null,
        gameArr: null,
        courtyardsArr: null,
        lobbiArr: null,
        safeArr: null,
        accentsArr: null,
        apartmentsArr: null,

        galleryArr: null,
        newsArr: null,
        newsData: null,

        isOpenFormModal: false,
        isOpenModalPromo: false,
        isOpenSendwich: false,
        isOpenFormLandModal: false,
        // flats CRM VARS
        salesCardPage: null,
        salesCardContent: null,
        saleFilterParams: null,
        flatsItems: null,
        flatCard: null,
        flatsFilterData: null,
        flatsPagination: {
            allApartments: 0,
            remainingApartments: 0,
            remainingPages: 0,
        },
        pagin_PageNumber: 1,
        gridView: true,
        flatsEmptyMsg: false,
        objectDataCrm: null,
        visibleFilterMobile: false,
        FilterResetTrigger: false,
        modalData: null,
        isMobileGlobal: null,
        ucoCRM_oauth_token: null,
        // gCap_siteKey: '6Lf9aM0pAAAAANTDHxNStBCrIsXAl2ZAOlI8ccBX',
        gCap_siteKey: '6LfxU24qAAAAALHq48_WqqAVA34XpQQkVrvScwHz',
    },
    getters: {
        loadGcap_sitekey: state => state.gCap_siteKey,
        loadIsOpenFormLandModal: state => state.isOpenFormLandModal,
        loadOpenFormModal: state => state.isOpenFormModal,
        loadOpenModalPromo: state => state.isOpenModalPromo,
        loadOpenSendwich: state => state.isOpenSendwich,
        //Get global lang Content Var
        loadPageSetUp: state => state.pageSetup,
        loadFormSetUp: state => state.formSetup,
        loadIndexPromo: state => state.indexPromo,
        loadAboutArr: state => state.aboutArr,
        loadLocationArr: state => state.locationArr,
        loadAroundArr: state => state.aroundArr,
        loadStudyArr: state => state.studyArr,
        loadGenplanArr: state => state.genplanArr,
        loadArchArr: state => state.archArr,
        loadTerracesArr: state => state.terracesArr,
        loadCityHousesArr: state => state.cityHousesArr,
        loadTaunHouseArr: state => state.taunHouse,
        loadStreetRetailArr: state => state.streetRetailArr,
        loadLandArr: state => state.landArr,
        loadGameArr: state => state.gameArr,
        loadCourtyardsArr: state => state.courtyardsArr,
        loadLobbiArr: state => state.lobbiArr,
        loadSafeArr: state => state.safeArr,
        loadAccentsArr: state => state.accentsArr,
        loadApartments: state => state.apartmentsArr,
        loadGalleryArr: state => state.galleryArr,
        loadNews: state => state.newsArr,
        loadNewsData: state => state.newsData,
        //getters for flats CRM
        loadSalesCardPage: state => state.salesCardPage,
        loadSalesCardContent: state => state.salesCardContent,
        loadSalesFilterCardParams: state => state.saleFilterParams,
        loadFlatsItems: state => state.flatsItems,
        loadFlatCard: state => state.flatCard,
        loadFlatsFilterData: state => state.flatsFilterData,
        loadFlatsPagination: state => state.flatsPagination, // параметры остаточных значений(счетчиков) пагинации
        loadPaginPageNumber: state => state.pagin_PageNumber,
        loadFlatsEmptyMsg: state => state.flatsEmptyMsg,
        loadObjectDataCrm: state => state.objectDataCrm,
        loadVisibleFilterMobile: state => state.visibleFilterMobile,
        loadLandFlatsGridView: state => state.gridView,
        loadSalesLandModalDataArr: state => state.modalData,
        loadResetTriggerMove: state => state.FilterResetTrigger,
        loadisMobileGlobal: state => state.isMobileGlobal,
        loadUcoCRM_auth_token: state => state.ucoCRM_oauth_token,
    },
    actions: {
        installMainLang_Global({commit}, payload) {
            commit('setUp_mainLang', payload);
        },
        clearNewsData({commit}) {
            commit('newsDataClear');
        },
        //// GLOBAL ACTIONS
        getSectionsData({commit}) {
            axios.get(window.url + window.GlobalLang + window.JsonUrl + 'section?per_page=25').then(async (response) => {
                // console.log(response.data[21].acf)
                if (this.state.pageSetup == null) {
                    return new Promise((resolve, reject) => {
                        commit('PageSetUp', response.data[0].acf);
                        commit('Forms', response.data[1].acf);
                        commit('IndexPromo', response.data[2].acf);
                        commit('aboutArr', response.data[3].acf);
                        commit('Location', response.data[4].acf);
                        commit('Around', response.data[5].acf);
                        commit('Study', response.data[6].acf);
                        commit('Genplan', response.data[7].acf);
                        commit('Arch', response.data[8].acf);
                        commit('Terraces', response.data[9].acf);
                        commit('CityHouses', response.data[10].acf);
                        commit('StreetRetail', response.data[11].acf);
                        commit('Land', response.data[12].acf);
                        commit('Game', response.data[13].acf);
                        commit('Courtyards', response.data[14].acf);
                        commit('Lobbi', response.data[15].acf);
                        commit('Safe', response.data[16].acf);
                        commit('Accents', response.data[17].acf);
                        commit('Apartments', response.data[18].acf);
                        commit('Gallery', response.data[19].acf);
                        commit('News', response.data[20].acf);
                        commit('TaunHouse', response.data[21].acf);
                        // resolve('complete Get SetUp');
                    });
                }
            });
        },
        // SALES CARD PROMO/LAND
        getSalesCardPageData({commit}) {
            axios.get(window.SalesURL + window.GlobalLang + window.JsonUrl + 'pages/1661').then(async (response) => {
                // console.log(response.data.acf, 'sale CARD PAGE DATA DEFAULT');
                commit('salesCardPage', response.data.acf);
            });
        },
        // FLATS FROM CRM
        //oauth 2.0 crm rest api
        getFlatsItems({commit}, payload) { // FLATS DEFAULT LOAD
            if (this.state.flatsItems == null) {
                return new Promise((resolve, reject) => {
                    crmPost('apartments', payload).then((response) => {
                        commit('flatsItemsArr', response.data.data);
                        resolve('complete FLATS');
                    }).catch((error) => {
                        console.log('error getApartments default', error.response ? error.response.status : error.message);
                    });
                });
            }
        },
        getFlatsByFilter({commit}, payload) { // FLATS LOAD BY FILTER
            crmPost('apartments', payload).then((response) => {
                commit('flatsItemsArr', response.data.data);
            }).catch((error) => {
                console.log('error getApartments filter', error.response ? error.response.status : error.message);
            });
        },
        getFlatsByPagination({commit}, payload) { // FLATS LOAD BY pagination
            crmPost('apartments', payload).then((response) => {
                commit('flatsItemsArrPagination', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination', error.response ? error.response.status : error.message);
            });
        },
        getFlatsPagintationCounters({commit}, payload) {
            crmPost('count', payload).then((response) => {
                commit('flatsPaginationCountersSet', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination Counter', error.response ? error.response.status : error.message);
            });
        },
        sendFormDataToCRM({commit}, payload) {
            return new Promise((resolve) => {
                crmPost('lead', payload).then((response) => {
                    resolve(response);
                }).catch((error) => {
                    console.log('error SEND FORM', error.response ? error.response.status : error.message);
                    resolve(error);
                });
            });
        },
    },
    mutations: {
        setOauthToken_from_server(state, data) {
            state.ucoCRM_oauth_token = data;
        },
        Open_form_modal(state, data) {
            state.isOpenFormModal = data
        },
        Open_promo_modal(state, data) {
            state.isOpenModalPromo = data
        },
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        //
        PageSetUp(state, data) {
            state.pageSetup = data
        },
        Forms(state, data) {
            state.formSetup = data
        },
        IndexPromo(state, data) {
            state.indexPromo = data
        },
        aboutArr(state, data) {
            state.aboutArr = data
        },
        Location(state, data) {
            state.locationArr = data
        },
        Around(state, data) {
            state.aroundArr = data
        },
        Study(state, data) {
            state.studyArr = data
        },
        Genplan(state, data) {
            state.genplanArr = data
        },
        Arch(state, data) {
            state.archArr = data
        },
        Terraces(state, data) {
            state.terracesArr = data
        },
        CityHouses(state, data) {
            state.cityHousesArr = data
        },
        Land(state, data) {
            state.landArr = data
        },
        StreetRetail(state, data) {
            state.streetRetailArr = data
        },
        Game(state, data) {
            state.gameArr = data
        },
        Courtyards(state, data) {
            state.courtyardsArr = data
        },
        Lobbi(state, data) {
            state.lobbiArr = data
        },
        Safe(state, data) {
            state.safeArr = data
        },
        Accents(state, data) {
            state.accentsArr = data
        },
        Apartments(state, data) {
            state.apartmentsArr = data
        },
        Gallery(state, data) {
            state.galleryArr = data
        },
        News(state, data) {
            state.newsArr = data
        },
        TaunHouse(state, data) {
            state.taunHouse = data
        },
        //////////// CRM BAZIS FLATS MUTATIONS
        salesCardPage(state, data) {
            state.salesCardPage = data;
        },
        salesCardContent(state, data) {
            state.salesCardContent = data;
        },
        FilterSaleItemCard_Set(state, data) {
            state.saleFilterParams = data
        },
        flatsItemsArr(state, data) {
            // console.log(data, 'test')
            state.flatsItems = data;
            if (data.length == 0) {
                state.flatsEmptyMsg = true
            } else {
                state.flatsEmptyMsg = false
            }
        },
        flatsItemsArrPagination(state, data) {
            // console.log(data, 'PAGINATION MUTATION');
            for (var i = 0; i < data.length; i++) {
                state.flatsItems.push(data[i]);
            }
            // console.log(state.flatsItems);
        },
        flatsPaginationCountersSet(state, data) {
            state.flatsPagination.allApartments = data.allApartments;
            state.flatsPagination.remainingApartments = data.remainingApartments;
            state.flatsPagination.remainingPages = data.remainingPages;
        },
        setObjectDataCRM(state, data) {
            state.objectDataCrm = data[0];
        },
        setFlatsFilterData(state, data) {
            state.flatsFilterData = data
        },
        UpdatePaginPageNumber(state, data) {
            state.pagin_PageNumber = data
        },
        // mutations for news section
        newsData(state, data) {
            state.newsData.push(data);
            // console.log(state.newsData, 'asdasdsad')
        },
        newsDataClear(state, data) {
            state.newsData = []
        },
        // for flats
        SetVisibleFilterMobile(state, data) {
            state.visibleFilterMobile = data
        },
        TriggerResetFilterMove(state, data) {
            state.FilterResetTrigger = data
        },
        gridView(state, data) {
            state.gridView = data;
        },
        modalData(state, data) {
            state.modalData = data
        },
        isMobileGlobalSet( state, data) {
            state.isMobileGlobal = data
        },
        Open_FormLandModal(state, data) {
            state.isOpenFormLandModal = data
        },
    },
})
